import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
// import { MdClose } from "react-icons/md";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import image from "../../images/MYPIC.png";
import profile from "../../images/profiledummy.png";
import { LuBadgeCheck } from "react-icons/lu";
import { MyContext } from "../../../context/MyContext";

const UserAccount = (props) => {



   
  const { verifyMlmUser, setVerifyMlmUser, pending, kycPending } =
    useContext(MyContext);
  const navigate = useNavigate();
  const [userProfile, setUserProfile] = useState({
    fullName: "",
    image: "",
  });
  const [KYC,setKYC]=useState('');
  const [bank,setBank]=useState('');
  const [loading, setLoading] = useState(true);
  const user = { image: image, dummy: profile };
  const userId = localStorage.getItem("userId") || null;
  const token = localStorage.getItem("token") || null;
  console.log(token);
  const [mobile, isMobileView] = useState(false);
  const { showUserAccount } = props;
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
    if (window.innerWidth < 420) {
      isMobileView(true);
    }
  }, []);

  const picture = localStorage.getItem("profilePicture");
  const userName = localStorage.getItem("userName");
  const userDetail = useSelector((state) => state.userProfile);

  console.log("data is", userDetail["User Profile"]);

  useEffect(() => {
    if (userId) {
      UserProfile();
    } else {
      navigate("/login-user");
    }
  }, []);

  // console.log("the redux profile in account now  is ", userProfile);
  const UserProfile = async () => {
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_NODE}user/profile/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("reponse is ", response.data.data.kyc_status);
          setKYC(response.data.data.kyc_status)
      setBank(response.data.data.filled_bankDetail);
      setUserProfile({
        fullName: response.data.data.first_name + response.data.user.last_name,
        image: response.data.data.profile_picture,
      });

      console.log("USERaCCOUNT", response.data["User Profile"]);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        console.log(error);
        console.error("Unauthorized: Invalid token or session expired.");
        // Optional: dispatch a logout or token refresh action
      } else {
        console.error("Error fetching user profile:", error);
      }
    } finally {
      setLoading(false);
    }
  };
  function setUserAccount() {
    showUserAccount();
  }

  const level = localStorage.getItem("level");
console.log(typeof(level));

  return (
    <>
      <div
        className="sticky top-24 z-30 shadow-lg bg-white flex flex-col p-5 pl-5 md:ml-0 -ml-[15px] w-[250px] max-sm:fixed max-sm:mt-0 max-sm:max-h-screen max-sm:overflow-y-auto"
      >
        {/* {mobile ? <MdClose onClick={setUserAccount} /> : ""} */}
        {loading ? (
          <div className="flex flex-col items-center gap-5 p-2 shadow-sm rounded-md">
            {/* User Profile Skeleton */}
            <div className="flex items-center gap-5 p-2 shadow-sm rounded-md">
              <Skeleton circle={true} height={64} width={64} />
              <div className="text-sm">
                <Skeleton width={50} height={16} />
                <Skeleton width={120} height={20} />
              </div>
            </div>

            {/* Mhttp://localhost:3000/account/addressesY ORDERS Section Skeleton */}
            <div className="">
              <Skeleton width={200} height={20} />
              <div className=" space-y-2">
                <Skeleton width={150} height={18} />
              </div>
            </div>

            {/* ACCOUNT SETTINGS Section Skeleton */}
            <div className="">
              <Skeleton width={200} height={20} />
              <ul className="mt-3 space-y-2">
                {[...Array(3)].map((_, index) => (
                  <Skeleton key={index} width={180} height={16} />
                ))}
              </ul>
            </div>

            {/* PAYMENTS Section Skeleton */}
            <div className="mt-5">
              <Skeleton width={200} height={20} />
              <ul className="mt-3 space-y-2">
                {[...Array(3)].map((_, index) => (
                  <Skeleton key={index} width={150} height={16} />
                ))}
              </ul>
            </div>
            {/* MY STUFF Section Skeleton */}
            <div className="mt-5">
              <Skeleton width={200} height={20} />
              <ul className="mt-3 space-y-2">
                {[...Array(3)].map((_, index) => (
                  <Skeleton key={index} width={170} height={16} />
                ))}
              </ul>
            </div>
            {/* Logout Skeleton */}
            <div className="mt-5">
              <Skeleton width={100} height={18} />
            </div>
          </div>
        ) : (
          <div className="flex items-center gap-2 p-2 shadow-sm rounded-md">
            {/* <img
              src={`${process.env.REACT_APP_NODE_CATEGORY}uploads/userProfile/${picture}`}
              alt={user.dummy}
              className="w-16 h-16 rounded-full"
            /> */}
            <div className="text-sm">
              <p className="text-gray-500">Hello,</p>
              <p className="font-semibold mt-1">{userName}</p>
              <p className="text-gray-500 font-semibold">{level=="null"?"":level}</p>
            </div>
            <div className="text-3xl mt-1">
              {verifyMlmUser === 1 ? (
                <LuBadgeCheck className="text-white fill-[#9333ea]" />
              ) : ""}
            </div>
          </div>
        )}
        <div className="mt-5">
          <Link to="/account/myorders">
            <h2 className="text-lg font-semibold mb-3 border-b pb-2">
              MY ORDERS
            </h2>
          </Link>
        </div>
        <div className="mt-5">
          <h2 className="text-lg font-semibold mb-3">ACCOUNT SETTINGS</h2>
          <ul className="space-y-2">
            <Link to="/account/account_details">
              <li className="hover:text-blue-500 mb-2 cursor-pointer">
                Profile Information
              </li>
            </Link>
            <Link to="/account/addresses">
              <li className="hover:text-blue-500 mb-2 cursor-pointer">
                Manage Addresses
              </li>
            </Link>
          </ul>
        </div>
        <div className="mt-5">
          <h2 className="text-lg font-semibold mb-3">PAYMENTS</h2>

          <ul className="space-y-2">
            <Link to="/teams">
              {verifyMlmUser == 1 && (
                <li className="hover:text-blue-500 cursor-pointer">Teams</li>
              )}
            </Link>

            {parseInt(localStorage.getItem("MLMStatus")) !== 0 && (
              <Link to="/user-bank-details">
                <li className=" pb-2 hover:text-blue-500 cursor-pointer"  >
                  Bank Details
               
                    <span className="text-white text-[0.6rem] ml-1 bg-red-500 p-1 rounded-lg">
                      {bank}
                    </span>
               
                </li>
              </Link>
            )}
            {parseInt(localStorage.getItem("MLMStatus")) !== 0 && (
              <Link to="/kyc-detail" >
                <li className="border-b pb-2 hover:text-blue-500 cursor-pointer"  >
                  KYC
         
                    <span className="text-white text-[0.6rem] ml-1 bg-red-500 p-1 rounded-lg">
                      {KYC}
                    </span>
             
                </li>
              </Link>
            )}
          </ul>
        </div>
        <div className="mt-5">
          <h2 className="text-lg font-semibold mb-3">MY STUFF</h2>
          <ul className="space-y-2">
            <Link to="/account/your-level">
              <ul></ul>
              <li className="border-b pb-2 hover:text-blue-500 cursor-pointer">
                Your Level
              </li>
            </Link>
            <Link to="/account/your-wallet">
              <ul></ul>
              {verifyMlmUser == 1 && (
                <li className="border-b pb-2 hover:text-blue-500 cursor-pointer">
                  Wallet
                </li>
              )}
            </Link>
            <Link to="/mou-download">
              <ul></ul>
              {verifyMlmUser == 1 && (
                <li className="border-b pb-2 hover:text-blue-500 cursor-pointer">
                  MOU Download
                </li>
              )}
            </Link>
            {/* <Link to="/mou-download">
              <ul></ul>
              <li className="border-b pb-2 hover:text-blue-500 cursor-pointer">
                MOU Download
              </li>
            </Link> */}
          </ul>
        </div>
        <div
          onClick={() => {
            localStorage.removeItem("token");
            localStorage.clear();
            // window.location.reload();
            navigate("/");
          }}
          className="mt-5  text-lg border-b pb-2 font-semibold hover:text-red-500 cursor-pointer"
        >
          LOGOUT
        </div>
      </div>
    </>
  );
};

export default UserAccount;
